import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import CustomCard from '../../shared/CustomCard';

const useStyles = makeStyles(() => ({
  titleContainer: {
    height: '60px',
    color: '#10182B',
    border: '1px solid #F4F4F4',
    padding: '20px',
  },
  titleText: {
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '22.4px',
    textAlign: 'center',
    justifyContent: 'center',
  },
  contentContainer: {
    height: '450px',
    background: '#F9FAFB',
    textAlign: 'center',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: '20px',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  emptyContainer: {
    width: '237px',
    height: '145px',
  },
  emptyText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '140%',
    textAlign: 'center',
    color: '#10182B',
  },
}));

const RightSideContest = () => {
  const classes = useStyles();
  const dealershipList = useSelector((state) => state.contestData.selectedContestDetails.dealerships);

  return (
    <Grid container direction="column" justifyContent="center">
      <Grid item className={classes.titleContainer}>
        <Grid container direction="row" justifyContent="flex-start">
          <Grid item className={classes.titleText}>
            Dealerships
          </Grid>
        </Grid>
      </Grid>
      {dealershipList?.length ? (
        <Grid item className={classes.contentContainer}>
          <Grid container direction="row" spacing={1} justifyContent="flex-start">
            {dealershipList.map((d) => (
              <Grid item key={d.id} style={{ marginTop: '8px' }}>
                <CustomCard
                  name="dealerships"
                  title={d.name}
                  subTitle={`Dealership ID ${d.id}`}
                  thirdTitle={`${d.employeeCount} Employees`}
                  status={d.enabled}
                  width="260px"
                  height="80px"
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      ) : (
        <Grid item className={classes.contentContainer}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            alignContent="center"
            style={{ height: '100%' }}
          >
            <Grid item className={classes.emptyContainer}>
              <Typography className={classes.emptyText}>You dont have any Dealership added in the Contest</Typography>
            </Grid>
            <Grid item></Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default RightSideContest;
